import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button, Loading, Alert } from 'element-react'

import { MainSection, Section } from '../../components/views/includes/Wrappers'
import { singleLineAddress } from '../../helpers/util'
import useAuth from '../../hooks/useAuth'
import useAdmin from '../../hooks/useAdmin'
import AppRoutes from '../../routes/appRoutes'

const AdminHomePage = () => {
    const {
        fetchCompanies,
        adminHasErrored,
        adminIsLoading,
        companies,
    } = useAdmin()
    const { role } = useAuth()

    useEffect(() => {
        fetchCompanies()
    }, [fetchCompanies])

    const companiesCopy = [...companies]

    return adminHasErrored ? (
        <Alert
            title="Sorry! There was an error loading user data."
            type="error"
            closable={false}
        />
    ) : adminIsLoading ? (
        <div className="padding-top-large padding-bottom-large">
            <Loading text="Loading" />
        </div>
    ) : (
        <MainSection className="admin--customer-list margin-top-medium">
            <Section>
                <strong className="font-600 text-xsmall secondary-color">
                    Customer List
                </strong>

                <ul className="table-list margin-bottom-large">
                    {companiesCopy &&
                        Array.isArray(companiesCopy) &&
                        companiesCopy
                            .sort((c1, c2) => {
                                // Alphabetical sort ignoring case
                                let a = c1.name.toLowerCase()
                                let b = c2.name.toLowerCase()
                                if (a < b) {
                                    return -1
                                }
                                if (a > b) {
                                    return 1
                                }
                                return 0
                            })
                            .map(company => (
                                <li key={`row-${company.id}`}>
                                    <Link
                                        to={AppRoutes.adminSearch(
                                            `?company=${company.id}`,
                                        )}
                                        className="tertiary-color font-600"
                                    >
                                        {company.name}
                                    </Link>
                                    <span className="secondary-color">
                                        {` - ${company.sap_id}`}
                                    </span>
                                    <div className="font-400 text-xsmall secondary-color">
                                        {singleLineAddress(
                                            company.shipping_street1,
                                            company.shipping_city,
                                            company.shipping_state,
                                            company.shipping_zip,
                                        )}
                                    </div>
                                </li>
                            ))}
                </ul>

                {role === 'admin' ? (
                    <Link to={AppRoutes.adminAddUser()}>
                        <Button type="primary" icon="plus">
                            &nbsp;Add New User
                        </Button>
                    </Link>
                ) : null}
            </Section>
        </MainSection>
    )
}

export default AdminHomePage
